import type React from "react";

interface StepperProps {
  active: "request" | "verify";
}

/**
 * Stepper component
 * Visual two-step indicator highlighting the active step.
 */
const Stepper: React.FC<StepperProps> = ({ active }) => {
  return (
    <div className="flex items-center gap-4 mb-4">
      <div className="flex items-center gap-3">
        <div
          className={`w-7 h-7 rounded-full flex items-center justify-center ${
            active === "request"
              ? "bg-primary text-white"
              : "bg-gray-200 text-muted-foreground"
          }`}
        >
          1
        </div>
        <div className="text-sm">Request</div>
      </div>
      <div className="flex-1 h-[1px] bg-gray-200" />
      <div className="flex items-center gap-3">
        <div
          className={`w-7 h-7 rounded-full flex items-center justify-center ${
            active === "verify"
              ? "bg-primary text-white"
              : "bg-gray-200 text-muted-foreground"
          }`}
        >
          2
        </div>
        <div className="text-sm">Verify & Reset</div>
      </div>
    </div>
  );
};

export default Stepper;
